// constants
import { RentalsActionTypes } from "./constants";

const INIT_STATE = {
  rentals: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface RentalsActionType {
  type: RentalsActionTypes.API_RESPONSE_SUCCESS | RentalsActionTypes.API_RESPONSE_ERROR | RentalsActionTypes.GET_RENTALS;
  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
  };
}

const Rentals = (state: any = INIT_STATE, action: RentalsActionType): any => {
  switch (action.type) {
    case RentalsActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case RentalsActionTypes.GET_RENTALS: {
          return {
            ...state,
            rentals: action.payload.data,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case RentalsActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case RentalsActionTypes.GET_RENTALS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        default:
          return { ...state };
      }

    case RentalsActionTypes.GET_RENTALS:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default Rentals;
